import { Route, Navigate } from "react-router-dom";
import { AdminUserPage } from "../../pages/entities/admin-user";
import { AnnouncePage } from "../../pages/entities/announce";
import { ContactPage } from "../../pages/entities/contact";
import { MaintenancePage } from "../../pages/entities/maintenance";
import { ResultPage } from "../../pages/entities/result";
import { ResultCategoryPage } from "../../pages/entities/result-category";

// UserIDを持つエンティティのルート（ユーザーに関連するエンティティ）
export const getUserRelatedRoutes = () => [];

// UserIDを持たないエンティティのルート（全般的なエンティティ）
// 注意: パスは /admin/* の子ルートとして使われるため、先頭の / は不要
export const getNonUserRelatedRoutes = () => [
  // お知らせ
  <Route
    key="announce-list"
    path="entities/announce"
    element={<AnnouncePage />}
  />,
  <Route
    key="announce-create"
    path="entities/announce/create"
    element={<AnnouncePage />}
  />,
  <Route
    key="announce-detail"
    path="entities/announce/:id"
    element={<AnnouncePage />}
  />,
  <Route
    key="announce-edit"
    path="entities/announce/:id/edit"
    element={<AnnouncePage />}
  />,
  // お問い合わせ（/admin直下に移動）
  <Route key="contact-list" path="" element={<ContactPage />} />,
  <Route
    key="contact-create"
    path="create"
    element={<Navigate to="/admin" replace />}
  />,
  <Route key="contact-detail" path=":id" element={<ContactPage />} />,
  <Route key="contact-edit" path=":id/edit" element={<ContactPage />} />,
  // メンテナンス
  <Route
    key="maintenance-list"
    path="entities/maintenance"
    element={<MaintenancePage />}
  />,
  // 施工実績
  <Route
    key="result-list"
    path="entities/result"
    element={<ResultPage />}
  />,
  <Route
    key="result-create"
    path="entities/result/create"
    element={<ResultPage />}
  />,
  <Route
    key="result-detail"
    path="entities/result/:id"
    element={<ResultPage />}
  />,
  <Route
    key="result-edit"
    path="entities/result/:id/edit"
    element={<ResultPage />}
  />,
  // 施工実績カテゴリ
  <Route
    key="result-category-list"
    path="entities/result-category"
    element={<ResultCategoryPage />}
  />,
  <Route
    key="result-category-create"
    path="entities/result-category/create"
    element={<ResultCategoryPage />}
  />,
  <Route
    key="result-category-detail"
    path="entities/result-category/:id"
    element={<ResultCategoryPage />}
  />,
  <Route
    key="result-category-edit"
    path="entities/result-category/:id/edit"
    element={<ResultCategoryPage />}
  />,
  // 管理ユーザー
  <Route
    key="admin-user-list"
    path="entities/admin-user"
    element={<AdminUserPage />}
  />,
];

// 全エンティティのルートを取得
export const getAllEntityRoutes = () => [
  ...getUserRelatedRoutes(),
  ...getNonUserRelatedRoutes(),
];
